import { useEffect, useState } from "react";

const PageLoader = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(true);
        }, 180); // Don't show for very fast page loads

        return () => clearTimeout(timer);
    }, []);

    if (!show) return null;

    return (
        <div className="flex h-full w-full items-center justify-center p-8">
            <div className="flex flex-col items-center gap-4">
                <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-slate-200 border-t-blue-600" />
                <p className="text-sm text-slate-500 dark:text-slate-400">Loading...</p>
            </div>
        </div>
    );
};

export default PageLoader;
